import { BaseModel } from "./base";

export class Horario extends BaseModel {
  constructor(
    public id: number,
    public nome: string,
    public cobrador: boolean,
    public horaSaida: string,
    public saidaIncial: string,
    public origem: string,
    public linhaId: number
  ) {
    super(id);
  }
}
